import React, { useContext } from 'react';
import classnames from 'classnames';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import SubmissionDetails from '../../../SubmissionDetails';
import { isExtendedDeviationFullyLoaded } from '../../../DeviationPage/redux/helpers';
import Stats from '../../../Stats';
import ExtendedDetails from './ExtendedDetails';
import s from './Default.scss';
export var DefaultDetails = function (_a) {
    var deviation = _a.deviation, className = _a.className, contentClassName = _a.contentClassName;
    var isExtendedLoaded = isExtendedDeviationFullyLoaded(deviation);
    var isMobile = useContext(MobileContext);
    var stats_on_the_right = useFlag('stats_on_the_right') && !isMobile;
    return (React.createElement("div", { className: classnames(s['root'], stats_on_the_right && s['stats_on_the_right'], className, contentClassName) },
        React.createElement("div", { className: s['title-block'], "data-hook": BiDataHook.DEVIATION_META },
            React.createElement(SubmissionDetails, { className: s['submission-details'], showTitle: true, deviation: deviation }),
            stats_on_the_right && isExtendedLoaded && (React.createElement(Stats, { className: s['stats'], deviation: deviation }))),
        isExtendedLoaded && (React.createElement(ExtendedDetails, { deviation: deviation, withStats: !stats_on_the_right }))));
};
DefaultDetails.displayName = 'DefaultDetails';
export default DefaultDetails;
//# sourceMappingURL=Default.js.map